module.exports = __webpack_public_path__ + "img/contact_icon_4.dd499bfe.png";